import { z } from "zod";
import { TovChannelRouteTypeSchema } from "../../enums/tov-voice";
import { TovDefinitionEvidenceResponseSchema } from "./evidence.responses";

// Channel placement sub-tree wire shapes. A channel nests its placements; each
// placement nests its objectives, content formats, metrics, routes and rule
// links.
const linkedEvidence = z.array(TovDefinitionEvidenceResponseSchema);

export const TovChannelObjectiveResponseSchema = z.object({
  id: z.uuid(),
  placementId: z.uuid(),
  objective: z.string(),
  displayOrder: z.number().int(),
  linkedEvidence,
});
export type TovChannelObjectiveResponse = z.infer<
  typeof TovChannelObjectiveResponseSchema
>;

export const TovChannelContentFormatResponseSchema = z.object({
  id: z.uuid(),
  placementId: z.uuid(),
  formatLabel: z.string(),
  displayOrder: z.number().int(),
  linkedEvidence,
});
export type TovChannelContentFormatResponse = z.infer<
  typeof TovChannelContentFormatResponseSchema
>;

export const TovChannelMetricResponseSchema = z.object({
  id: z.uuid(),
  placementId: z.uuid(),
  metricLabel: z.string(),
  measurementContext: z.string().nullable(),
  displayOrder: z.number().int(),
  linkedEvidence,
});
export type TovChannelMetricResponse = z.infer<
  typeof TovChannelMetricResponseSchema
>;

export const TovChannelRouteResponseSchema = z.object({
  id: z.uuid(),
  placementId: z.uuid(),
  routeType: TovChannelRouteTypeSchema,
  label: z.string(),
  displayOrder: z.number().int(),
  linkedEvidence,
});
export type TovChannelRouteResponse = z.infer<
  typeof TovChannelRouteResponseSchema
>;

export const TovChannelRuleResponseSchema = z.object({
  id: z.uuid(),
  placementId: z.uuid(),
  ruleId: z.uuid(),
});
export type TovChannelRuleResponse = z.infer<
  typeof TovChannelRuleResponseSchema
>;

export const TovChannelPlacementResponseSchema = z.object({
  id: z.uuid(),
  channelId: z.uuid(),
  journeyStageId: z.uuid().nullable(),
  role: z.string(),
  displayOrder: z.number().int(),
  linkedEvidence,
  objectives: z.array(TovChannelObjectiveResponseSchema),
  contentFormats: z.array(TovChannelContentFormatResponseSchema),
  metrics: z.array(TovChannelMetricResponseSchema),
  routes: z.array(TovChannelRouteResponseSchema),
  rules: z.array(TovChannelRuleResponseSchema),
});
export type TovChannelPlacementResponse = z.infer<
  typeof TovChannelPlacementResponseSchema
>;

export const TovChannelResponseSchema = z.object({
  id: z.uuid(),
  versionId: z.uuid(),
  key: z.string(),
  label: z.string(),
  description: z.string(),
  displayOrder: z.number().int(),
  linkedEvidence,
  placements: z.array(TovChannelPlacementResponseSchema),
});
export type TovChannelResponse = z.infer<typeof TovChannelResponseSchema>;
